import { useEffect, useState } from "react";
import { getInvoiceWasteSummary } from "../../../services";
import { InvoiceWasteSummary } from "../../../types/invoice-waste";

/**
 * The price ladder + ค่าปรับ total behind one sale report.
 *
 * `version` is a **reconcile_sk**, the same namespace `GET /invoice-waste` takes — NOT a
 * sales-report version. The two tabs of the report page hold versions from different
 * namespaces in the same state, so a caller on the รายงานการขาย tab must pass nothing and
 * let the API resolve the active reconcile; only the ใบจ่ายสินค้า tab has a version this
 * endpoint can use. Passing the wrong one silently answers for another day.
 *
 * Failures resolve to `null` rather than throwing: this annotates a report that reads fine
 * without it (a report with no waste checker has no ladder at all), so the panel disappears
 * instead of taking the page down with it.
 */
export function useInvoiceWasteSummary(
  reportId?: string,
  version?: string,
  triggerFetch?: number,
) {
  const [summary, setSummary] = useState<InvoiceWasteSummary | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!reportId) return;
    let cancelled = false;
    setLoading(true);
    getInvoiceWasteSummary(reportId, version)
      .then(({ data: { data } }) => {
        if (!cancelled) setSummary(data ?? null);
      })
      .catch(() => {
        if (!cancelled) setSummary(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reportId, version, triggerFetch]);

  return { summary, loading };
}
